var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},_vm._l((_vm.links),function(link){return _c('div',{key:link.path},[_c('router-link',{attrs:{"to":link.path}},[_vm._v("/"+_vm._s(link.path))])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }